import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatStorageSize, formatNumber } from "utils/helpers";

const useOverviewBucketsColumnConfig = () => {
  const { t } = useTranslation("storageOverview");

  return useMemo(
    () => [
      {
        key: "bucketName",
        dataIndex: "bucketName",
        title: t("table.columns.name"),
        width: "30%",
      },
      {
        key: "bucketSize",
        dataIndex: "bucketSize",
        title: t("table.columns.size"),
        width: "20%",
        render: (value: number) => formatStorageSize(value),
      },
      {
        key: "objects",
        dataIndex: "objects",
        title: t("table.columns.objects"),
        width: "25%",
        render: (value: number) => formatNumber(value),
      },
      {
        key: "location",
        dataIndex: "location",
        title: t("table.columns.location"),
        width: "25%",
      },
    ],
    []
  );
};

export default useOverviewBucketsColumnConfig;
